<template>
  <div v-loading="isLoading" v-if="grupos">
    <el-row>
      <el-col :span="6">
        <el-card class="mr-2">
          <div slot="header" class="clearfix">
            <strong>Seeders</strong>
          </div>
          <ul class="list-group">
            <li v-bind:class="{ 'indicador-active': grupo.id === grupoSelected.id }"
                class="list-group-item clickable" v-for="grupo in grupos" @click="onChangeGrupo(grupo)">
              <span style="font-size: .8em ; font-weight: bold">
                {{grupo.nome}}
                <span class="badge pull-right" :class="classBadge(grupo.progresso)">{{grupo.progresso}}</span>
              </span>
            </li>
          </ul>
        </el-card>

      </el-col>
      <transition name="fade" mode="out-in">
        <el-col :span="18" v-if="grupoSelected">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <el-row>
                <el-col :span="8">
                  <strong> Respostas - {{grupoSelected.nome}}</strong>
                </el-col>
                <el-col>
                  <el-input placeholder="Buscar..." v-model="qryFilter"></el-input>
                </el-col>
              </el-row>
            </div>
            <el-alert  v-if="!respostasFiltered.length"
              title="Sem Respostas"
              type="warning">
            </el-alert>
            <table class="table table-striped table-bordered table-respostas" v-else >
              <thead class="thead-dark">
              <tr>
                <th class="text-center">ID</th>
                <th class="text-center">Centro Custo</th>
                <th class="text-center">Grupo</th>
                <th class="text-center">Pergunta</th>
                <th class="text-center">Resposta</th>
              </tr>
              </thead>
              <tr v-for="item in respostasFiltered" key="item.indicador_id">

                <td style=" font-weight: bold">
                  <span class="badge" :class="classBadge(item.progresso)">{{item.id}}</span>
                </td>
                <td class="text-left">
                  {{item.centro_custo_nome}}
                </td>
                <td class="text-left">
                  {{item.pergunta_grupo_nome}}
                </td>
                <td class="text-left">
                  {{item.pergunta}}
                </td>
                <td class="text-right">
                  {{item.resposta}}
                </td>
              </tr>
            </table>
          </el-card>
        </el-col>
      </transition>
    </el-row>
  </div>
</template>

<script>
  import {mapActions, mapState} from 'vuex'
  import {MessageBox, Notification} from 'element-ui'
  import {openAside} from "../../domain/utils";

  export default {
    name: "CompetenciaResposta",
    props: ['competencia'],
    data() {
      return {
        qryFilter: "",
        listChildrens: [],
        isLoading: false,
        grupoSelected: {},
        grupos: [],
        itens: []
      }
    },
    computed: {
      respostasFiltered() {
        if (!this.qryFilter) {
          return this.listChildrens
        }

        return this.listChildrens.filter(item => {
          return item.pergunta.toUpperCase().indexOf(this.qryFilter.toUpperCase()) > -1
        })
      }
    },
    methods: {
      ...mapActions('Competencia', ['restaurarPesos', 'atualizarMetas']),
      classBadge: function (progresso) {
        return {
          'badge-warning': progresso >= 50 && progresso < 100,
          'badge-success': progresso >= 100,
          'badge-danger': progresso < 50,
        }
      },
      onChangeGrupo(item) {
        this.grupoSelected = {...item}
        let {id} = this.grupoSelected
        this.listChildrens = collect(this.itens)
          .where('grupo_id', id).all()
      },
      async load() {
        try {
          this.isLoading = true
          const {data} = await axios.get(`${process.env.API_PATH}/resposta/ano/${this.competencia.ano}/mes/${this.competencia.mes}`)
          this.grupos = [...data.seeders]
          this.itens = [...data.respostas]
          if (this.grupos.length > 0) {
            this.onChangeGrupo(this.grupos[0])
          }
        } catch (e) {
          console.log(e)
        } finally {
          this.isLoading = false
        }
      }
    },
    async mounted() {
      await this.load()
    }
  }
</script>

<style scoped>
  .indicador-active {
    background-color: #9933CC;
    color: #fff;
  }

  .table-respostas {
    font-size: .8em;
  }
</style>



// WEBPACK FOOTER //
// src/features/Competencia/Resposta.vue